import { useHistory, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Avatar, Badge, IconButton } from "@mui/material";
import { BellIcon } from "@assets";
import { useDispatch } from "react-redux";

import { linkImage, theme } from "@utils";
import { StyledAppTopBar } from ".";
import { AppModal } from "..";
import { ModalMenu } from "@components";
// import logo from "@assets/Icons/logo.svg";
import { appRouteEnums } from "@enums";
import { resetMenu, selectMenu, useAppSelector, selectAuth, selectNoti } from "@redux";
// import { GREETING_HELLO, NUMBER_TEXT_USERNAME } from "@configs";
import { StyledStickyHeader } from "src/Components/styles";
// import { HiOutlineClipboardList } from "react-icons/hi";
import BackIcon from "@assets/ProceedButton.svg";

type IProps = {
  screen?: string;
};

const maintinance = false;

export const AppTopBar = (props: IProps) => {
  const { screen } = props;
  // redux state
  const menu = useAppSelector(selectMenu);
  const auth = useAppSelector(selectAuth);
  const noti = useAppSelector(selectNoti);
  const { userInfo } = auth;
  const { show } = menu;
  // hooks
  const history = useHistory();
  const dispatch = useDispatch();

  const location = useLocation();
  const hiddenPaths = ["/"];
  // 子SPA(名刺)の戻れる状態と、最後に受信した子オリジン
  const [cardsCanGoBack, setCardsCanGoBack] = useState<boolean>(false);
  const [cardsOrigin, setCardsOrigin] = useState<string | undefined>(undefined);

  // 子SPA(名刺) → 親 の状態通知を購読
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const data = (event as any)?.data;
      if (!data || typeof data !== "object") return;
      if (data.type === "CARDS_ROUTE") {
        // 子の現在ルートに応じた戻れる/戻れないを受け取る
        setCardsCanGoBack(Boolean(data.canGoBack));
        // 返信先オリジンは受信イベントの origin を採用
        setCardsOrigin(event.origin);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  
  // event close modal
  const handleCloseModal = () => {
    dispatch(resetMenu());
  };
  
  // 戻るボタンの処理（サイドメニューから来た場合はトップに戻る）
  const handleBack = () => {
    // 名刺モジュール配下の場合は子SPAに委譲
    if (location.pathname.startsWith('/business-cards')) {
      try {
        // iframe は兄弟コンポーネント配下のため、ここで useRef を直接共有できない。
        // Context 等で ref を配布する設計も可能だが、cross-tree の配線コストが高い。
        // 本件は一意の iframe への送信のみが目的のため、DOMから id で取得する方が単純で安全。
        const iframe = document.getElementById('cards-iframe') as HTMLIFrameElement | null;
        const frameWin = iframe?.contentWindow;
        // 初回通知前でも正しい targetOrigin を推定できるよう、iframe.src のオリジンを利用
        let targetOrigin = cardsOrigin;
        if (!targetOrigin && iframe?.src) {
          try { targetOrigin = new URL(iframe.src).origin; } catch { /* noop */ }
        }
        if (frameWin && cardsCanGoBack) {
          frameWin.postMessage({ type: 'PARENT_BACK' }, targetOrigin || '*');
          return;
        }
        // 子で戻れない（=名刺トップ）場合は既存ロジックへフォールバック
      } catch (_) {
        // 失敗時は既存ロジックへフォールバック
      }
    }

    const searchParams = new URLSearchParams(location.search);
    const fromParam = searchParams.get('from');
    
    if (fromParam === 'sidemenu') {
      // サイドメニューから来た場合はトップに戻る
      history.push(appRouteEnums.PATH_HOME);
    } else {
      // それ以外はブラウザの履歴を使って戻る
      history.goBack();
    }
  };
  
  // event open modal
  // const handleOpenModal = () => {
  //   dispatch(setMenu());
  // };
  // get width of screen
  return (
    <StyledStickyHeader>
      <StyledAppTopBar screen={screen}>
        <div className="topbar">
          {!hiddenPaths.includes(location.pathname) &&
            <div className="backIcon-container"
              onClick={handleBack}
            >
              <img src={BackIcon} alt="back-icon" className="backIcon" />
            </div>
          }

          <div className="topbar__right-btnBell">
            <IconButton onClick={() => history.push(appRouteEnums.PATH_NOTIFICATION)} size="large">
              <Badge
                badgeContent={noti.numberNoti}
                overlap="circular"
                style={{
                  transform: "translate(30px, -20px)",
                  fontSize: "1.4rem",
                }}
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: theme.colors.crimson,
                    color: theme.colors.white00,
                  },
                  transform: "translate(30px, -20px)",
                }}
              ></Badge>
              <BellIcon />
            </IconButton>
            {/* </Tooltip> */}
          </div>

          <div className="topbar__userInfo" onClick={() => history.push(appRouteEnums.PATH_PROFILE)}>
            <Avatar src={linkImage(userInfo?.avatar?.path)} />
          </div>
        </div>
        <AppModal open={show} handleClose={handleCloseModal}>
          <ModalMenu />
        </AppModal>
      </StyledAppTopBar>
      <span style={{ display: maintinance ? "flex" : "none", background: "#f88", justifyContent: "center", padding: "1rem", fontSize: "2rem", color: "#800", fontWeight: "bold" }}>このサイトは現在読み取り専用です。追加されたコンテンツは失われる可能性があります。</span>
    </StyledStickyHeader>
  );
};
